<div class="fullcontainer" >
  <app-workshop-nav></app-workshop-nav>

    <br />
    <br />
  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Workshop Job Signoff</h2>


    <div>
      <!-- <button class='btn btn-secondary' routerLink='/quoting/new/accounts'><i class="fas fa-plus"></i> New</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/quoting/products'><i class="fas fa-boxes"></i> Manage Products</button> -->
    </div>

  </div>

  <br />
  <br />
  
  <app-tabs >
    <app-tab title='Fitter Sign off'>
        <app-job-signoff-workshop-fitter></app-job-signoff-workshop-fitter>
    </app-tab>
    <app-tab  title='Manager Sign off'>
      <app-job-signoff-workshop-manager></app-job-signoff-workshop-manager>
    </app-tab>
  </app-tabs>
